import { render, staticRenderFns } from "./NumEntries.vue?vue&type=template&id=4b2f1e67&scoped=true&"
import script from "./NumEntries.vue?vue&type=script&lang=ts&"
export * from "./NumEntries.vue?vue&type=script&lang=ts&"
import style0 from "./NumEntries.vue?vue&type=style&index=0&id=4b2f1e67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f1e67",
  null
  
)

export default component.exports